<template>
    <div class="">
        <div class="d-none d-md-block">
        <!-- Navbar1  -->
          <b-navbar class="nav1">
            <a 
            href="#"
            @click.prevent="goHome"
            >
            <img class="logo" 
              src="/img/logo-enterprise.png"/>
            </a>
            <!-- flag -->
            <a
            href="#" 
            @click="goHome"
            >
            <img class="flag" 
              src="/img/flag.jpg"/>
            </a>
          <div style="" class="divnav">
            <b-list-group  style="" class="" horizontal>

              <b-list-group-item class="backcolor mt-1 ">
                <a class="navfont" href="tel:+1 866-961-3133">{{$t('masternav.call_usa')}}  (+1) 866-961-3133</a>
              </b-list-group-item>

              <!--<b-list-group-item class="backcolor mt-1 ">
                <b-link class="navfont text-right " router-link :to="{name: 'Covid19'}">COVID-19
                  <svg class="bi bi-box-arrow-up-right" width="2em" height="1.3em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M1.5 13A1.5 1.5 0 0 0 3 14.5h8a1.5 1.5 0 0 0 1.5-1.5V9a.5.5 0 0 0-1 0v4a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 5v8zm7-11a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.5H9a.5.5 0 0 1-.5-.5z"/>
                    <path fill-rule="evenodd" d="M14.354 1.646a.5.5 0 0 1 0 .708l-8 8a.5.5 0 0 1-.708-.708l8-8a.5.5 0 0 1 .708 0z"/>
                  </svg>
                </b-link>
              </b-list-group-item>-->

              <!-- si está autenticado-->
              
                  <!-- <b-list-group-item class="backcolor mt-1" v-show="isAuth">
                      <b-link class="navfont text-right " router-link :to="{name: 'test'}">test</b-link>
                  </b-list-group-item> -->

              
              <b-list-group-item class="backcolor ml-4 mt-1">
                <b-link 
                :class="visibleHelp ? null : 'not-collapsed'"
                :aria-expanded="visibleHelp ? 'true' : 'false'"
                aria-controls="collapse-help"
                @click="visibleHelp = !visibleHelp"
                class="navfont  text-capitalize" 
                >{{$t('masternav.help')}}</b-link>
              </b-list-group-item>
              <b-list-group-item 
              class="backcolor ml-4"
              style="margin-top:0px;">
                <b-link 
                :class="visibleLang ? null : 'not-collapsed'"
                :aria-expanded="visibleLang ? 'true' : 'false'"
                aria-controls="collapse-lang"
                @click="visibleLang = !visibleLang"
                class="navfont "
                >
                  <img class="icon text-white" src="/img/globe.PNG"/>
                  Panamá ({{ $t('switch_traslade.langs') }})
                </b-link>
              </b-list-group-item>
              <!-- <b-list-group-item>
              </b-list-group-item>   -->
                <!--v2 login-->
                <b-list-group-item  class="backcolor  ml-4 mr-4" v-show="isAuth">
                  
                    <b-dropdown id="dropdown-form" variant="link" right toggle-class="text-decoration-none" no-caret>
                       <template #button-content>
                          <button v-if="auth" class="signbtn text-right"  @click="errors = []">{{user.nombre}} {{user.apellido_paterno}}</button>
                          <button v-else class="signbtn text-right"  @click="errors = []">Iniciar Sesión</button>
                      </template>
                      <b-dropdown-form>
                        <div v-if="auth" style="width: 260px;">
                          <b-button variant="success" block squared class="button_panel text-uppercase" router-link :to="{name: 'perfil'}">Mi Perfil</b-button>
                          <b-button variant="success" block squared class="button_panel text-uppercase" router-link :to="{name: 'Panel'}">Reservas activas</b-button>
                        </div>
                        <div v-else>
                          <b-form-group label="Email" label-for="dropdown-form-email" style="width: 260px;">
                          <b-form-input
                            id="dropdown-form-email"
                            size="sm"
                            placeholder="email@example.com"
                            v-model="form.email"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group label="Password" label-for="dropdown-form-password">
                          <b-form-input
                            id="dropdown-form-password"
                            type="password"
                            size="sm"
                            placeholder="Password"
                            v-model="form.password"
                          ></b-form-input>
                        </b-form-group>
                        </div>
                        <b-button v-if="auth" variant="danger"  @click.prevent="logout" :disabled="spinner" class="mt-2" style="width: 100%;">
                          <span v-if="spinner"><b-spinner small></b-spinner>Cerrando sesión...</span>
                          <span v-else>CERRAR SESIÓN</span>
                        </b-button>
                        <b-button v-else class="signbtn" size="sm" @click="loginv2" :disabled="spinner" style="width: 100%;">
                          <span v-if="spinner"><b-spinner small></b-spinner>Iniciando...</span>
                          <span v-else>Accesar</span>
                        </b-button>
                        <p class="text-danger" v-for="(error, index) in errors" :key="index">{{ error.email[0] }}</p>
                      </b-dropdown-form>
                      <b-dropdown-divider></b-dropdown-divider>
                      <div v-if="!auth">
                        <b-dropdown-item :to="{ name: 'registro'}">Registrarme</b-dropdown-item>
                        <b-dropdown-item :to="{name:'recuperar-password'}">¿Olvidó su contraseña?</b-dropdown-item>
                      </div>
                    </b-dropdown>
                </b-list-group-item>
                <!--v2 login-->
            </b-list-group>
          </div>
          </b-navbar>
        </div>
        <!-- Collapsible Lenguage -->
          <div class="d-none d-sm-none	d-md-none d-md-block">
          <b-collapse id="collapse-lang" v-model="visibleLang">
            <b-card class="cardlang " >
                <p class=" ml-2 titlehelp text-capitalize">{{$t('masternav.select_lang')}}</p>
                <br><br>
                <a class="textmenu ml-2"
                @click.prevent="cambiarIdioma('en'), visibleLang = !visibleLang"
                > 
                English
                </a>
                <br>
                <a class="textmenu ml-2"
                @click.prevent="cambiarIdioma('es'), visibleLang = !visibleLang"
                > 
                Español
                </a>
                <!-- <br>
                <a class="textmenu ml-2" 
                @click="$i18n.locale = 'es', visibleLang = !visibleLang"
                >Español</a> -->
            </b-card>
          </b-collapse>
        </div>
        <!-- /////////Buttons for collapse menu/////// -->
        <div class="d-none d-md-block">
        <div class=" btn-group d-flex " role="group" aria-label="...">
          <!-- //////////////Rent button collapse//////////// -->
          <button 
          :class="visible1 ? null : 'not-collapsed'"
          :aria-expanded="visible1 ? 'true' : 'false'"
          aria-controls="collapse-1"
          @click="visible1 = !visible1"
          v-bind:style="bgc1"
          type="button" 
          class=" button btn-default w-100 ">
          <p class="textfont text-capitalize"> {{$t('masternav.rent')}}</p>
          </button>
          <!-- //////////////Flota button collapse//////////// -->
          <button 
          router-link :to="{name: 'Fleet'}"
          @click="visibleNav = !visibleNav"
          v-bind:style="bgc2"
          type="button" 
          class=" button btn-default w-100 ">
          <router-link :to="{name: 'Fleet'}">
          <p class="textfont text-capitalize" > {{$t('masternav.fleet')}}  </p>
          </router-link>
          </button>
          <!-- //////////////Locations button collapse//////////// -->
          <button 
          :class="visible3 ? null : 'collapsed'"
          :aria-expanded="visible3 ? 'true' : 'false'"
          aria-controls="collapse-3"
          @click="visible3 = !visible3, getcitiesList()" 
          v-bind:style="bgc3"
          type="button" 
          class=" button btn-default w-100 ">
          <p class="textfont text-capitalize"> {{$t('masternav.locations')}}</p>
          </button>
          <!-- //////////////Leasing button collapse//////////// -->
          <button 
          :class="visible4 ? null : 'collapsed'"
          :aria-expanded="visible4 ? 'true' : 'false'"
          aria-controls="collapse-4"
          @click="visible4 = !visible4"
          v-bind:style="bgc4"
          type="button" 
          class=" button btn-default w-100 ">
          <p class="textfont text-capitalize"> {{$t('masternav.leasing')}}</p>
          </button>
          <!-- //////////////Business button collapse//////////// -->
          <button 
          :class="visible5 ? null : 'collapsed'"
          :aria-expanded="visible5 ? 'true' : 'false'"
          aria-controls="collapse-5"
          @click="visible5 = !visible5"
          v-bind:style="bgc5"
          type="button" 
          class=" button btn-default w-100 ">
          <p class="textfont text-capitalize"> {{$t('masternav.discover')}}</p>
          </button>
        <!-- ////////// End buttons collapse/////////// -->
        </div>
        </div>

        <!-- Collapsible Help/Ayuda -->
          <div class="d-none d-sm-none	d-md-none d-md-block">
          <b-collapse id="collapse-help" v-model="visibleHelp">
            <b-card class="cardhelp " >
                <b-row>
                  <b-col class="text-white text-left border-right border-secondary">
                    <p class=" ml-2 titlehelp text-capitalize">{{$t('buttons_label.customer_service')}}</p>
                    <br><br>
                    <router-link 
                    style="text-decoration: none;" 
                    :to="{name: 'Help'}">
                    <a  class="helpbtn ml-2 text-uppercase">
                      {{$t('buttons_label.customer_service')}}
                    </a>
                    </router-link>
                  </b-col>
                  <!-- column 2 -->
                  <b-col class="text-white text-left">
                    <p class=" ml-3 titlehelp text-capitalize">{{$t('masternav.contact_us')}}</p>
                    <br><br>
                    <router-link 
                    style="text-decoration: none;" 
                    :to="{name: 'Contact'}">
                    <a style="width:277px;" 
                    class="helpbtn ml-3 text-uppercase">
                    {{$t('buttons_label.contact')}}</a>
                    </router-link>
                  </b-col>
                </b-row>
            </b-card>
          </b-collapse>
        </div>
                <!-- Collapsible menu 5 -->
        <div class="d-none d-sm-none	d-md-none d-md-block">
          <b-collapse id="collapse-5" v-model="visible5">
            <b-card class="cards" >
                <b-row>
                  <b-col class="text-white" cols="3">
                    <div class="border-right border-secondary">
                    <div class="ml-5 mt-5">
                      <br>
                      <p class="titlefont text-capitalize">{{$t('masternav.company')}}</p>
                      <div class="mt-4">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link :to="{name: 'About'}" class="textmenu">
                             <a class="textmenu text-capitalize" @click="visible5 = !visible5">{{$t('masternav.about')}}
                             </a>
                           </router-link>
                           <br>
                      </div>

                   </div>
                   <br><br><br><br><br>
                   </div>
                   </b-col>
                  <!-- column 2 -->
                  <b-col class="text-white" cols="4">
                    <!--<div class="">
                    <div class="m-5">
                      <br>
                      <p class="titlefont text-capitalize">{{$t('masternav.loyalty')}}</p>
                      <div class="mt-4">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu text-capitalize">{{$t('masternav.corporate')}} {{$t('masternav.soon')}}</a><br>
                      </div>
                      <div class="mt-3">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu text-capitalize">{{$t('masternav.privilege')}} {{$t('masternav.soon')}}</a><br>
                      </div>
                      <br>
                      </div>
                   </div>-->

                  </b-col>
                  <!-- column 3 -->
                  <b-col class="" cols="5">
                    <img class="collapseimg" src="/img/amador2.png"/>
                  </b-col>
                </b-row>
            </b-card>
          </b-collapse>
        </div>

                <!-- Collapsible menu 4 -->
        <div class="d-none d-sm-none	d-md-none d-md-block">
          <b-collapse id="collapse-4" v-model="visible4">
            <b-card class="cards" >
                <b-row>
                  <b-col class="text-white" cols="7">
                    <div class=" border-secondary">
                    <div class="m-5">
                      <br>
                      <p class="titlefont">Leasing</p>
                      <div class="mt-4">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link :to="{name: 'Leasing'}" class="textmenu"><a class="textmenu text-capitalize">{{$t('masternav.leasing_ope')}}</a></router-link><br>
                      </div>
                      <!-- <div class="mt-4">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu" href="">Cotizar</a><br>
                      </div> -->
                      <div class="mt-3">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link :to="{name: 'Contact'}" class="textmenu"><a class="textmenu text-capitalize">{{$t('masternav.contact_us')}}</a></router-link><br>
                      </div>
                      <br>
                      </div>
                   </div>
                  </b-col>

                  <b-col class="" cols="5">
                    <img class="collapseimg" src="/img/hiace3.jpg"/>
                  </b-col>
                </b-row>
            </b-card>
          </b-collapse>
        </div>

                <!-- Collapsible menu 3 -->
        <div class="d-none d-sm-none	d-md-none d-md-block">
          <b-collapse id="collapse-3" v-model="visible3">
            <b-card class="cards" >
                <b-row>
                  <!-- <b-col class="text-white" cols="3">
                    <div class="border-right border-secondary">
                    <div class="ml-3 mt-5">
                      <p class="titlefont mr-1">Oficinas de renta de autos</p>
                      <div class="mt-4">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link to="/locations">
                           <a class="textmenu">Oficinas en Panamá</a>
                           </router-link>
                      </div>
                      <div class="mt-4">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link to="/office">
                           <a class="textmenu">Albrook Village</a>
                           </router-link><br>
                      </div>
                      <div class="mt-1">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu" href="">Calle 50</a><br>
                      </div>
                      <div class="mt-1">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu" href="">El Cangrejo</a><br>
                      </div>
                      <div class="mt-1">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu" href="">Tocúmen</a><br>
                      </div>
                      <div class="mt-1">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu" href="">Albrook Aeropuerto</a><br>
                      </div>
                      <div class="mt-1">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu" href="">Costa del Este</a><br>
                      </div>
                   </div>
                   <br>
                   </div>
                  </b-col> -->
                  <!-- column 2 -->
                  <b-col class="text-white" cols="4">
                    <div class="ml-5 border-right border-secondary">
                    <div class=" mt-5">
                      <p class="titlefont text-capitalize">{{$t('masternav.rent_locations')}}</p>
                      <div class="mt-4">
                        <p class="titlefont"></p>
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           
                           <router-link
                           :to="{name: 'Locations'}">
                           <a @click="visible3 = !visible3, locationFilterSelected='1',locationFiltering()"
                           class="textmenu text-capitalize"
                           >{{$t('masternav.all_locations')}}</a>
                           </router-link>
                      </div>
                      <div class="mt-4"
                      >
                        <p v-if="this.enablecity=='1'">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link
                           :to="{name: 'Locations'}">
                           <a @click="visible3 = !visible3, locationFilterSelected='1',locationFiltering()" class="textmenu text-capitalize" >{{$t('masternav.city_locations')}}</a>
                           </router-link>
                           <br>
                        </p>
                        <p v-if="this.enablechi=='1'">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link 
                           :to="{name: 'Locations'}">
                           <a @click="visible3 = !visible3, locationFilterSelected='2',locationFiltering()" class="textmenu text-capitalize" >{{$t('masternav.chiriqui_locations')}}</a>
                           </router-link>
                           <br>
                        </p>
                        <p v-if="this.enablecoc=='1'">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link 
                           :to="{name: 'Locations'}">
                           <a @click="visible3 = !visible3, locationFilterSelected='3',locationFiltering()" class="textmenu text-capitalize" >{{$t('masternav.cocle_locations')}}</a>
                           </router-link>
                           <br>
                        </p>
                      </div>
                      <!-- <div class="mt-4">
                        <p class="titlefont"></p>
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link 
                           :to="{name: 'Locations'}">
                           <a @click="visible3 = !visible3, locationFilterSelected='8',locationFiltering()" class="textmenu text-capitalize" >{{$t('masternav.chiriqui_locations')}}</a>
                           </router-link>
                      </div>
                      <div class="mt-4">
                        <p class="titlefont"></p>
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link 
                           :to="{name: 'Locations'}">
                           <a @click="visible3 = !visible3, locationFilterSelected='9',locationFiltering()" class="textmenu text-capitalize" >{{$t('masternav.cocle_locations')}}</a>
                           </router-link>
                      </div> -->
                      <!-- <div class="mt-1">
                        <p class="titlefont">Coclé</p>
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu mr-1" href="">Playa Blanca, Mareas Mall</a><br>
                      </div> -->
                   </div>
                   <br>
                   </div>
                   
                  </b-col>
                  
                  <!-- COLUMN 3 -->
                  <b-col class="text-white" cols="3">
                    <div class="">
                    <div class=" mt-5">
                      <p class="titlefont text-capitalize">{{$t('masternav.other_locations')}}</p>
                      <!-- <div class="mt-4">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu" href="">Oficinas de renta de autos en Estados Unidos</a><br>
                      </div> -->
                      <div class="mt-3">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link 
                           :to="{name: 'Locations'}">
                           <a @click="visible3 = !visible3" class="textmenu text-capitalize">{{$t('masternav.intl_locations')}}</a>
                           </router-link><br>
                      </div>

                   </div>
                   
                   </div>
                  </b-col>
                  <b-col class="" cols="5">
                    <img class="collapseimg" src="/img/ubicacion.png"/>
                  </b-col>
                </b-row>
            </b-card>
          </b-collapse>
        </div>

                <!-- Collapsible menu 2 -->
        <div class="d-none d-sm-none	d-md-none d-md-block">
          <b-collapse id="collapse-2" v-model="visible2">
            <b-card class="cards" >
                <b-row>
                  <!-- column 1 -->
                  <b-col class="text-white" cols="7">
                    <div class="">
                    <div class="ml-5 mt-5">
                      <br>
                      <p class="titlefont">Vehículos</p>
                      <!-- test modal //////////////////////// -->
                      <!-- <b-modal id="modal-sm" size="sm" title="Small Modal">
                             <div class="mt-3">Selected: <p>{{  }}</p></div>
                      </b-modal> -->
                      <div class="mt-4">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu"  v-b-modal.modal-sm>Autos</a><br>
                           <b-button @click="mutateCarFilter('Autos')" v-b-modal.modal-sm>ok</b-button>
                      </div>
                      <div class="mt-3">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu"  v-b-modal.modal-sm>SUV´s</a><br>
                      </div>
                      <div class="mt-3">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu"  v-b-modal.modal-sm>Van</a><br>
                      </div>
                      <div class="mt-3">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu"  v-b-modal.modal-sm>Comercial</a><br>
                      </div>
                      <br><br><br><br>
                      </div>
                   </div>
                  </b-col>
                  <b-col class="" cols="5">
                    <img class="collapseimg" src="/img/soluto.jpg"/>
                  </b-col>
                </b-row>
            </b-card>
          </b-collapse>
        </div>

        <!-- Collapsible menu 1 -->
        <div class="d-none d-sm-none	d-md-none d-md-block">
          <b-collapse id="collapse-1" v-model="visible1">
            <b-card class="cards" >
                <b-row >
                  <b-col class="text-white" cols="3">
                    <div class="border-right border-secondary">
                    <div class="ml-5 mt-5">
                      <br>
                      <p class="titlefont text-capitalize">{{$t('masternav.reservations')}}</p>
                      <div class="mt-4">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link :to="{name: 'Home'}" class="textmenu"> <a class="textmenu text-capitalize" @click="visible1 = !visible1">{{$t('masternav.cars_rent')}}</a></router-link><br>
                      </div>
                      <!-- <div class="mt-3">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <a class="textmenu" href="">Ver/Modificar/Cancelar</a><br>
                      </div> -->
                      <div class="mt-3">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link :to="{name: 'Promo'}" class="textmenu"><a class="textmenu text-capitalize">{{$t('masternav.promotions')}}</a></router-link><br>
                      </div>
                      <div class="mt-3">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link :to="{name: 'RentTerms'}" class="textmenu"><a class="textmenu text-capitalize">{{$t('masternav.rent_terms')}}</a></router-link><br>
                      </div>
                   </div>
                   <br><br>
                   </div>
                  </b-col>
                  <!-- COLUMN 2 -->
                  <b-col class="text-white" cols="4">
                    <div class="">
                    <div class="ml-5 mt-5">
                      <br>
                      <p class="titlefont text-capitalize">{{$t('masternav.learn_more')}}</p>
                      <div class="mt-4">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link :to="{name: 'Help'}" class="textmenu"><a class="textmenu text-capitalize">{{$t('masternav.questions')}}</a></router-link><br>
                      </div>
                      <div class="mt-3">
                           <svg class="bi bi-chevron-right" width="1em" height="0.7em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                             <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                           </svg>
                           <router-link :to="{name: 'Terms'}" class="textmenu"><a class="textmenu text-capitalize" >{{$t('masternav.terms_conditions')}}</a></router-link><br>
                      </div>

                   </div>
                   <br>
                   </div>
                  </b-col>
                  <!-- COLUMN 3 -->
                  <b-col class="" cols="5">
                    <img class="collapseimg" src="/img/rentimg.png"/>
                  </b-col>
                </b-row>
            </b-card>
          </b-collapse>
        </div>
<!-- ////////////////////////////////////////////////////////// -->
<!-- ////////             MOBILE NAVBAR             /////////// -->
<!-- ////////////////////////////////////////////////////////// -->
        <div class="mobilenav d-xl-none d-md-none w-100">
          <b-navbar toggleable type="" variant="">
            <b-navbar-brand href="#">
              <router-link :to="{name: 'Home'}"><img class="iconlogo" 
              src="/img/icon-enterprise.png"/>
              </router-link>
            </b-navbar-brand>
           
            <!--  -->
            
            <b-list-group style="margin-top: -12px !important; padding-right:15px " class="" v-show="isAuth">
            <b-list-group-item  class="backcolor  ml-4 mr-4">
                  
                    <b-dropdown id="dropdown-form" variant="link" right toggle-class="text-decoration-none" no-caret>
                       <template #button-content>
                          <button v-if="auth" class="signbtn" style="font-size:10px;"  @click="errors = []">{{user.nombre}} {{user.apellido_paterno}}</button>
                          <button v-else class="signbtn"  @click="errors = []">Iniciar Sesión</button>
                      </template>
                      <b-dropdown-form>
                        <div v-if="auth" style="width: 220px;">
                          <b-button variant="success" block squared class="" router-link :to="{name: 'perfil'}">Mi Perfil</b-button>
                          <b-button variant="success" block squared class="" router-link :to="{name: 'Panel'}">Reservas activas</b-button>
                        </div>
                        <div v-else>
                          <b-form-group label="Email" label-for="dropdown-form-email" style="width: 220px;">
                          <b-form-input
                            id="dropdown-form-email"
                            size="sm"
                            placeholder="email@example.com"
                            v-model="form.email"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group label="Password" label-for="dropdown-form-password">
                          <b-form-input
                            id="dropdown-form-password"
                            type="password"
                            size="sm"
                            placeholder="Password"
                            v-model="form.password"
                          ></b-form-input>
                        </b-form-group>
                        </div>
                        <b-button v-if="auth" variant="danger"  @click.prevent="logout" :disabled="spinner" class="mt-2" style="width: 100%;">
                          <span v-if="spinner"><b-spinner small></b-spinner>Cerrando sesión...</span>
                          <span v-else>CERRAR SESIÓN</span>
                        </b-button>
                        <b-button v-else class="signbtn" size="sm" @click="loginv2" :disabled="spinner" style="width: 100%;">
                          <span v-if="spinner"><b-spinner small></b-spinner>Iniciando...</span>
                          <span v-else>Accesar</span>
                        </b-button>
                        <p class="text-danger" v-for="(error, index) in errors" :key="index">{{ error.email[0] }}</p>
                      </b-dropdown-form>
                      <b-dropdown-divider></b-dropdown-divider>
                      <div v-if="!auth">
                        <b-dropdown-item :to="{ name: 'registro'}">Registrarme</b-dropdown-item>
                        <b-dropdown-item :to="{name:'recuperar-password'}">¿Olvidó su contraseña?</b-dropdown-item>
                      </div>
                    </b-dropdown>
                </b-list-group-item>
            </b-list-group>
            <!--  -->
            <button
              class="btnnavmob "
              v-bind:style="bgcNav"
              :class="visibleNav ? null : 'not-collapsed'"
              :aria-expanded="visibleNav ? 'true' : 'false'"
              aria-controls="collapse-nav"
              @click="visibleNav = !visibleNav"
              >
              <hr class="iconham ml-2 mr-2">
              <hr class="mt-1 iconham ml-2 mr-2">
            </button>
          </b-navbar>
          <!--  -->
          <div v-if="hover">
                    <b-card
                    @mouseleave="hover = false"  
                    class="cardtotals text-white " 
                    >
                    <div class="ml-2 mr-2 border-bottom dinregular">
                      <h4 class="">Panel de usuario</h4>
                      <br>
                      <!-- <b-button class="textmenu border bg-none border-white dinregular" variant="outline-dark" squared ><h5>Reservas activas</h5></b-button><br><br>
                      <b-button class="textmenu border bg-none border-white dinregular" variant="outline-dark" squared ><h5>Historial</h5></b-button>  -->
                      <b-button variant="success" block squared class="button_panel text-uppercase" router-link :to="{name: 'Panel'}">Reservas activas</b-button>
                      <!-- <b-button variant="success" block squared class="button_panel text-uppercase" router-link :to="{name: 'Panel'}">Historial</b-button> -->
                      <br><br>
                    </div>
                    <b-row class="m-1 dinregular">
                      <b-button variant="danger" @click.prevent="logout" squared class="text-white text-right button" @mouseover="hover=true">CERRAR SESIÓN</b-button>
                    </b-row>
                    </b-card>
                </div>
        </div>
        <!-- Collapsible menu nav mobile -->
        <div class="d-xl-none d-md-none">
          <b-collapse id="collapse-nav" v-model="visibleNav">
            <b-card class="cardnav" >
              <!-- lang select -->
              <div class="text-white border border-white">
                <p class="textmenu mt-3 ml-3" v-b-toggle.collapse-nav1>PANAMÁ ({{ $t('switch_traslade.langs') }})
                <svg width="1em" height="1em" viewBox="0 0 16 16" style="position:absolute;right:30px; padding:2px" class="bi bi-chevron-down mt-1" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                </p> 
                <b-collapse id="collapse-nav1" class=" cardnav">
                  <hr class="bg-white ml-2 mr-2">
                  <p class="ml-5 dinbold text-uppercase">{{$t('masternav.select_lang')}}</p>
                <b-card class="cardnav">
                    <a class="ml-4 dinregular textmenu"
                    @click.prevent="cambiarIdioma('en'), visibleNav = !visibleNav"
                    >English</a>
                    <br><br>
                    <a class="ml-4 mt-3 dinregular textmenu"
                    @click.prevent="cambiarIdioma('es'), visibleNav = !visibleNav"
                    >Español</a>
                </b-card>
              </b-collapse> 
              </div> 
              <br>
      <!-- Rent option menu -->
              <div class="text-white border-white">
                <p class="ml-1 dinregular text-capitalize">{{$t('masternav.rent')}}</p>
                <p class="textmenu mt-3 ml-1 text-capitalize" v-b-toggle.collapse-1stmenu>{{$t('masternav.reservations')}} 
                <svg width="1em" height="1em" viewBox="0 0 16 16" style="position:absolute;right:30px; padding:2px;" class="bi bi-chevron-down mt-1" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                </p> 
                <b-collapse id="collapse-1stmenu" class=" cardnav">
                  <hr class="bg-secondary ml-2 mr-2">
                <b-card class="cardnav">
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">
                        <router-link
                           :to="{name: 'Home'}">
                           <a @click="visibleNav = !visibleNav" class="textmenu text-capitalize" >{{$t('masternav.cars_rent')}}</a>
                        </router-link>
                      </a>
                    </p>
                    <!--  -->
                    <!-- <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">Ver/Modificar/Cancelar</a>
                    </p> -->
                    <!--  -->
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <router-link class="textmenu" :to="{name: 'Promo'}">
                      <a @click="visibleNav = !visibleNav" class="ml-3 textmenu text-capitalize">{{$t('masternav.promotions')}}</a>
                      </router-link>
                    </p>
                    <!--  -->
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <router-link class="textmenu" :to="{name: 'RentTerms'}">
                      <a @click="visibleNav = !visibleNav" class="ml-3 textmenu text-capitalize">{{$t('masternav.terms_conditions')}}</a>
                      </router-link>
                    </p>
                </b-card>
                <hr class="bg-secondary ml-2 mr-2">
              </b-collapse> 
              <!-- 2nd option Rent menu -->
              <p class="textmenu mt-3 ml-1 text-capitalize" v-b-toggle.collapse-2ndmenu>{{$t('masternav.learn_more')}} 
                <svg width="1em" height="1em" viewBox="0 0 16 16" style="position:absolute;right:30px; padding:2px" class="bi bi-chevron-down mt-1" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                </p> 
                <b-collapse id="collapse-2ndmenu" class=" cardnav">
                  <hr class="bg-secondary ml-2 mr-2">
                <b-card class="cardnav">
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <router-link class="textmenu" :to="{name: 'Help'}">
                      <a @click="visibleNav = !visibleNav" class="ml-3 textmenu text-capitalize">{{$t('masternav.help')}}</a>
                      </router-link>
                    </p>
                    <!--  -->
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <router-link class="textmenu" :to="{name: 'Terms'}">
                      <a @click="visibleNav = !visibleNav" class="ml-3 textmenu text-capitalize">{{$t('masternav.terms_conditions')}}</a>
                      </router-link>
                    </p>
                    
                </b-card>
                <hr class="bg-secondary ml-2 mr-2">
              </b-collapse> 
              </div> 
              <br>
      <!-- Fleet option menu -->
              <div class="text-white border-white">
                <router-link class="titlemobilewhite" :to="{name: 'Fleet'}" >
                <p @click="visibleNav = !visibleNav" class="ml-1 dinregular titlemobilewhite text-capitalize">{{$t('masternav.fleet')}}
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-box-arrow-up-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.5 13A1.5 1.5 0 0 0 3 14.5h8a1.5 1.5 0 0 0 1.5-1.5V9a.5.5 0 0 0-1 0v4a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 5v8zm7-11a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.5H9a.5.5 0 0 1-.5-.5z"/>
                  <path fill-rule="evenodd" d="M14.354 1.646a.5.5 0 0 1 0 .708l-8 8a.5.5 0 0 1-.708-.708l8-8a.5.5 0 0 1 .708 0z"/>
                </svg></p>
                </router-link>
                <!-- <p class="textmenu mt-3 ml-1" v-b-toggle.collapse-fleetmenu>Vehículos 
                <svg width="1em" height="1em" viewBox="0 0 16 16" style="position:absolute;right:30px; padding:2px" class="bi bi-chevron-down mt-1" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                </p>  -->
                <!-- <b-collapse id="collapse-fleetmenu" class=" cardnav">
                  <hr class="bg-secondary ml-2 mr-2">
                <b-card class="cardnav">
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">Autos</a>
                    </p>
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">SUV´s</a>
                    </p>
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">Van</a>
                    </p>
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">Comercial</a>
                    </p>
                </b-card>
                <hr class="bg-secondary ml-2 mr-2">
              </b-collapse> -->
              </div> 
              <br>
      <!-- Locations option menu -->
              <div class="text-white border-white">
                <p class="ml-1 dinregular text-capitalize">{{$t('masternav.locations')}}</p>
                <p class="textmenu mt-3 ml-1 text-capitalize" v-b-toggle.collapse-1stLOCATIONmenu>{{$t('masternav.rent_locations')}}
                <svg width="1em" height="1em" viewBox="0 0 16 16" style="position:absolute;right:30px; padding:2px;" class="bi bi-chevron-down mt-1" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                </p> 
                <b-collapse id="collapse-1stLOCATIONmenu" class=" cardnav">
                  <hr class="bg-secondary ml-2 mr-2">
                <b-card class="cardnav">
                  <p class="ml-1 dinregular">Panamá</p>
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">
                    <router-link
                    :to="{name: 'Locations'}">
                    <a @click="visibleNav = !visibleNav, locationFilterSelected='',locationFiltering()"
                    class="textmenu text-capitalize"
                    >{{$t('masternav.all_locations')}}</a>
                    </router-link>
                      </a>
                    </p>
                    <!--  -->
                    <p v-if="this.enablecity=='1'" class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">
                        <router-link
                           :to="{name: 'Locations'}">
                           <a @click="visibleNav = !visibleNav, locationFilterSelected='1',locationFiltering()" class="textmenu text-capitalize" >{{$t('masternav.city_locations')}}</a>
                        </router-link>
                      </a>
                    </p>
                    <!--  -->
                    <p v-if="this.enablechi=='1'" class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">
                        <router-link 
                           :to="{name: 'Locations'}">
                           <a @click="visibleNav = !visibleNav, locationFilterSelected='2',locationFiltering()" class="textmenu text-capitalize" >{{$t('masternav.chiriqui_locations')}}</a>
                        </router-link>
                      </a>
                    </p>
                    <!--  -->
                    <p v-if="this.enablecoc=='1'" class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">
                        <router-link 
                           :to="{name: 'Locations'}">
                           <a @click="visibleNav = !visibleNav, locationFilterSelected='3',locationFiltering()" class="textmenu text-capitalize" >{{$t('masternav.cocle_locations')}}</a>
                        </router-link>
                      </a>
                    </p>
                    <!--  -->
                    <!-- <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">Albrook Aeropuerto</a>
                    </p> -->
                    <!--  -->
                    <!-- <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">Costa del este</a>
                    </p>
                    <p class="ml-1 dinregular">Chiriquí</p>
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">Chiriquí, David</a>
                    </p>
                    <p class="ml-1 dinregular">Coclé</p>
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">Playa Blanca, Mareas Mall</a>
                    </p> -->
                </b-card>
                <hr class="bg-secondary ml-2 mr-2">
              </b-collapse> 
              <!-- 2nd option locations menu -->
              <p class="textmenu mt-3 ml-1 text-capitalize" v-b-toggle.collapse-2ndLOCATIONSmenu>{{$t('masternav.other_locations')}}
                <svg width="1em" height="1em" viewBox="0 0 16 16" style="position:absolute;right:30px; padding:2px" class="bi bi-chevron-down mt-1" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                </p> 
                <b-collapse id="collapse-2ndLOCATIONSmenu" class=" cardnav">
                  <hr class="bg-secondary ml-2 mr-2">
                <b-card class="cardnav">
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a class="ml-3 textmenu">
                        <router-link 
                           :to="{name: 'Locations'}">
                           <a @click="visibleNav = !visibleNav" class="textmenu text-capitalize" >{{$t('masternav.intl_locations')}} (Soon)</a>
                        </router-link>
                      </a>
                    </p>
                </b-card>
                <hr class="bg-secondary ml-2 mr-2">
              </b-collapse> 
              </div> 
              <br>
      <!-- Leasing option menu -->
              <div class="text-white border-white">
                <p class="ml-1 dinregular text-capitalize">{{$t('masternav.leasing')}}</p>
                <router-link class="textmenu" :to="{name: 'Leasing'}">
                <p @click="visibleNav = !visibleNav" class="textmenu mt-3 ml-1 text-capitalize" >{{$t('masternav.leasing_ope')}}
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-box-arrow-up-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.5 13A1.5 1.5 0 0 0 3 14.5h8a1.5 1.5 0 0 0 1.5-1.5V9a.5.5 0 0 0-1 0v4a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 5v8zm7-11a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.5H9a.5.5 0 0 1-.5-.5z"/>
                  <path fill-rule="evenodd" d="M14.354 1.646a.5.5 0 0 1 0 .708l-8 8a.5.5 0 0 1-.708-.708l8-8a.5.5 0 0 1 .708 0z"/>
                </svg>
                </p> 
                </router-link>
              <!-- 2nd option leasing menu -->
              <router-link class="textmenu" :to="{name: 'Contact'}">
              <p @click="visibleNav = !visibleNav" class="textmenu mt-3 ml-1 text-capitalize" >{{$t('masternav.contact_us')}}
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-box-arrow-up-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.5 13A1.5 1.5 0 0 0 3 14.5h8a1.5 1.5 0 0 0 1.5-1.5V9a.5.5 0 0 0-1 0v4a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 5v8zm7-11a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.5H9a.5.5 0 0 1-.5-.5z"/>
                  <path fill-rule="evenodd" d="M14.354 1.646a.5.5 0 0 1 0 .708l-8 8a.5.5 0 0 1-.708-.708l8-8a.5.5 0 0 1 .708 0z"/>
                </svg>
              </p> 
              </router-link>
              </div> 
              <br>
      <!-- Discover option menu -->
              <div class="text-white border-white">
                <p class="ml-1 dinregular text-capitalize">{{$t('masternav.discover')}}</p>
                <p class="textmenu mt-3 ml-1 text-capitalize" v-b-toggle.collapse-1stDISCOVERmenu>{{$t('masternav.company')}}
                <svg width="1em" height="1em" viewBox="0 0 16 16" style="position:absolute;right:30px; padding:2px;" class="bi bi-chevron-down mt-1" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                </p> 
                <b-collapse id="collapse-1stDISCOVERmenu" class=" cardnav">
                  <hr class="bg-secondary ml-2 mr-2">
                <b-card class="cardnav">
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <router-link class="textmenu" :to="{name: 'About'}">
                      <a @click="visibleNav = !visibleNav" class="ml-3 textmenu text-capitalize">{{$t('masternav.about')}}</a>
                      </router-link>
                    </p>
                </b-card>
                <hr class="bg-secondary ml-2 mr-2">
              </b-collapse> 
              <!-- 2nd option locations menu -->
              <p class="textmenu mt-3 ml-1 text-capitalize" v-b-toggle.collapse-2ndDISCOVERmenu>{{$t('masternav.loyalty')}}
                <svg width="1em" height="1em" viewBox="0 0 16 16" style="position:absolute;right:30px; padding:2px" class="bi bi-chevron-down mt-1" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                </p> 
                <b-collapse id="collapse-2ndDISCOVERmenu" class=" cardnav">
                  <hr class="bg-secondary ml-2 mr-2">
                <b-card class="cardnav">
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <a @click="visibleNav = !visibleNav" class="ml-3 textmenu text-capitalize">{{$t('masternav.privilege')}} (Soon)</a>
                    </p>
                </b-card>
                <hr class="bg-secondary ml-2 mr-2">
              </b-collapse> 
              </div> 
              <br>
              <hr class="bg-white w-100">
      <!-- Help option menu -->
              <div class="text-white border-white">
                <p class="textmenu mt-3 ml-1 text-capitalize" v-b-toggle.collapse-1stHELPmenu>{{$t('masternav.help')}}
                <svg width="1em" height="1em" viewBox="0 0 16 16" style="position:absolute;right:30px; padding:2px;" class="bi bi-chevron-down mt-1" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                </p> 
                <b-collapse id="collapse-1stHELPmenu" class=" cardnav">
                  <hr class="bg-secondary ml-2 mr-2">
                <b-card class="cardnav">
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <router-link class="textmenu" :to="{name: 'Help'}">
                      <a @click="visibleNav = !visibleNav" class="ml-3 textmenu text-capitalize">{{$t('buttons_label.customer_service')}}</a>
                      </router-link>
                    </p>
                    <!--  -->
                    <p class="dinregular">
                      <svg width="1em" height="1em" style="padding:2px" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      </svg> 
                      <router-link class="textmenu" :to="{name: 'Contact'}">
                      <a @click="visibleNav = !visibleNav" class="ml-3 textmenu text-capitalize">{{$t('buttons_label.contact')}}</a>
                      </router-link>
                    </p>
                </b-card>
                <hr class="bg-secondary ml-2 mr-2">
              </b-collapse>
              </div> 
            </b-card>
          </b-collapse>
        </div>
<!-- ////////////////////////////////////////////////////////// -->
<!-- ////////        FINISH  MOBILE NAVBAR          /////////// -->
<!-- ////////////////////////////////////////////////////////// -->        
        <!-- cookie -->
        <div>
          <b-alert
            v-model="showBottom"
            class="cookie position-fixed fixed-bottom m-0 rounded-0"
            style="z-index: 2000;"
            
          >
          <b-row>
            <b-col md="7" >
              <p class="cookietext ml-4">
              {{$t('cookie.cook7')}}
              <b-link class="text-success text-right " :to="{name: 'Cookies'}">{{$t('cookie.cook8')}}
                  <svg class="bi bi-box-arrow-up-right" width="2em" height="1.3em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M1.5 13A1.5 1.5 0 0 0 3 14.5h8a1.5 1.5 0 0 0 1.5-1.5V9a.5.5 0 0 0-1 0v4a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 5v8zm7-11a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.5H9a.5.5 0 0 1-.5-.5z"/>
                    <path fill-rule="evenodd" d="M14.354 1.646a.5.5 0 0 1 0 .708l-8 8a.5.5 0 0 1-.708-.708l8-8a.5.5 0 0 1 .708 0z"/>
                  </svg>
              </b-link>
              </p>
            </b-col>
            <b-col md="5"  class="text-center">
              <!-- <b-button 
              squared 
              class="cookiebuttonwhite mt-3 m-1" 
              href=""
              >MODIFICAR
              </b-button> -->
              <b-button 
              squared 
              class="cookiebutton mt-3 m-1" 
              href=""
              @click="persist()"
              >{{$t('cookie.btn')}}
              </b-button>
            </b-col>
          </b-row>
            
          </b-alert>
        </div>
        <!-- end cookie -->
    </div>
</template>

<script>
import { lang } from 'moment';
import axios from 'axios'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'masternav',
  components:{
    
  },
      data() {
      return {
        errors:[],
        spinner:false,
        form:{
                brand: 3,
                email: '',
                password: ''
        },
        hover:false,
        locationFilterSelected:'',
        showBottom: '',
        cities_filter:[],
        cities_filtered:[],
        city_panama: ["Ciudad de Panamá"],
        enablecity:'',
        enablechi:'',
        enablecoc:'',
        visible1: false,
        visible2: false,
        visible3: false,
        visible4: false,
        visible5: false,
        visibleHelp: false,
        visibleLang: false,
        visibleNav: false,
        lang: 'es',
        cookie: '',
        bgc1: {
			      backgroundColor: '',
            border: ''
        },
        bgc2: {
            backgroundColor: '',
            border: ''
        },
        bgc3: {
            backgroundColor: '',
            border: ''
        },
        bgc4: {
            backgroundColor: '',
            border: ''
        },
        bgc5: {
            backgroundColor: '',
            border: ''
		    },
        bgcHelp: {
            backgroundColor: '',
            border: ''
        },
        bgcLang: {
            backgroundColor: '',
            border: ''
        },
        bgcNav: {
            backgroundColor: '',
            border: ''
        }
      }
    },
    created(){
      this.getcitiesList()
    },
    mounted() {
      if (localStorage.cookie == 'accepted') {
        this.showBottom = false;
      }
    },
    computed:{
      ...mapState(['menulocationfilter','locations','cities', 'cliente']),
      ...mapState('autenticacion', ['user', 'modoClientes', 'auth']),
      ...mapGetters('autenticacion',['isAuth'])
      
    },
    methods: {
      ...mapActions(['addLocationMenuFilter','getcitiesList']),
      ...mapMutations('autenticacion', ['SET_TOKEN']),

    openModalLogin()
    {
      this.$bvModal.show('modal-login')
    },
    loginv2()
    {
      this.spinner = !this.spinner

      axios.post('login', this.form).then(resp=>{
                localStorage.removeItem('access_token')
                localStorage.setItem('access_token', resp.data)
                this.$store.dispatch('autenticacion/getUser')
                this.$bvToast.toast('Bienvenido', {
                        variant: 'success',
                        solid: true,
                        toaster:'b-toaster-top-center'
                        }) 
                if (this.$route.name != "Home") {
                    this.$router.push({name: "Home"})
                }
                this.errors = []
                this.spinner = !this.spinner
                this.SET_TOKEN(resp.data)
            }).catch(e=>{
              this.spinner = !this.spinner
                this.errors = []
                this.errors.push(e.response.data.errors)
            })
    },
    // cierra la sesión
        logout(){
          this.spinner = !this.spinner
            axios.post('logout', {brand:3}).then(()=>{
                localStorage.removeItem('access_token')
                if (this.$route.name != "Home") {
                    this.$router.push({name: "Home"})
                }
                location.reload()
            })
        },
    persist() {
        this.cookie = 'accepted'
        localStorage.cookie = this.cookie;
        this.showBottom = false
      },
    locationFiltering(){
      this.addLocationMenuFilter(this.locationFilterSelected)
    },
    cambiarIdioma(idioma){
				this.$i18n.locale = idioma
				this.$router.push({
					params: {lang: idioma}
				}).catch(()=>{});
      },
    goHome()
    {
        location.replace('/')
    }, 
    },
    watch: {
      cities: {
        handler: function(val, oldVal) {
				if(val){
          this.cities_filtered = Object.entries(this.cities.data);

          this.cities_filtered.forEach(([key, value]) => {
              if(key.includes('panama') && value==true){
                this.enablecity='1'
               
              }
              if(key.includes('chiriqui') && value==true){
                this.enablechi='1'
                
              }
              if(key.includes('cocle') && value==true){
                this.enablecoc='1'
             
              }
            /* console.log(key); // 'one'
            console.log(value); // 1 */
          });
          /* console.log('cities tiene cambios') */
          }
        }
      },
			visible1: {
        handler: function(val, oldVal) {
				if(val){
          this.visible2 = false
          this.visible3 = false
          this.visible4 = false
          this.visible5 = false
          this.visibleHelp = false
          this.visibleLang = false
          this.bgc1.backgroundColor = '#181918'
          this.bgc1.border = '#181918'
			   }else{
           this.bgc1.backgroundColor = '',
           this.bgc1.border = ''
         }
        }      
      },
      visible2: {
        handler: function(val, oldVal) {
				if(val){
          this.visible1 = false
          this.visible3 = false
          this.visible4 = false
          this.visible5 = false
          this.visibleHelp = false
          this.visibleLang = false
          this.bgc2.backgroundColor = '#181918'
          this.bgc2.border = '#181918'
			   }else{
           this.bgc2.backgroundColor = '',
           this.bgc2.border = ''
         }
        }      
      },
      visible3: {
        handler: function(val, oldVal) {
				if(val){
          this.visible1 = false
          this.visible2 = false
          this.visible4 = false
          this.visible5 = false
          this.visibleHelp = false
          this.visibleLang = false
          this.bgc3.backgroundColor = '#181918'
          this.bgc3.border = '#181918'
			   }else{
           this.bgc3.backgroundColor = '',
           this.bgc3.border = ''
         }
        }      
      },
      visible4: {
        handler: function(val, oldVal) {
				if(val){
          this.visible1 = false
          this.visible2 = false
          this.visible3 = false
          this.visible5 = false
          this.visibleHelp = false
          this.visibleLang = false
          this.bgc4.backgroundColor = '#181918'
          this.bgc4.border = '#181918'
			   }else{
           this.bgc4.backgroundColor = '',
           this.bgc4.border = ''
         }
        }      
      },
      visible5: {
        handler: function(val, oldVal) {
				if(val){
          this.visible1 = false
          this.visible2 = false
          this.visible3 = false
          this.visible4 = false
          this.visibleHelp = false
          this.visibleLang = false
          this.bgc5.backgroundColor = '#181918'
          this.bgc5.border = '#181918'
			   }else{
           this.bgc5.backgroundColor = '',
           this.bgc5.border = ''
         }
        }      
			},
      visibleHelp: {
        handler: function(val, oldVal) {
				if(val){
          this.visible1 = false
          this.visible2 = false
          this.visible3 = false
          this.visible4 = false
          this.visible5 = false
          this.visibleLang = false
          this.bgcHelp.backgroundColor = '#181918'
          this.bgcHelp.border = '#181918'
			   }else{
           this.bgcHelp.backgroundColor = '',
           this.bgcHelp.border = ''
         }
        }      
      },
      visibleLang: {
        handler: function(val, oldVal) {
				if(val){
          this.visible1 = false
          this.visible2 = false
          this.visible3 = false
          this.visible4 = false
          this.visible5 = false
          this.visibleHelp = false
          this.bgcLang.backgroundColor = '#181918'
          this.bgcLang.border = '#181918'
			   }else{
           this.bgcLang.backgroundColor = '',
           this.bgcLang.border = ''
         }
        }      
			},
      visibleNav: {
        handler: function(val, oldVal) {
				if(val){
          this.visible1 = false
          this.visible2 = false
          this.visible3 = false
          this.visible4 = false
          this.visible5 = false
          this.visibleHelp = false
          this.bgcNav.backgroundColor = '#181918'
          this.bgcNav.border = '#181918'
			   }else{
           this.bgcNav.backgroundColor = '',
           this.bgcNav.border = ''
         }
        }      
			}       
    }
}
</script>

<style scoped lang="scss">
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');  
}
.dinregular{
  font-family: 'DIN 2014-Regular';
}
.dinbold{
  font-family: 'DIN 2014-ExraBold';
}
.titlemobilewhite {
  font-family: 'DIN 2014-Regular', sans-serif;
  color: #ffffff;
  text-decoration: none !important;
  outline: 0;
}
.cardtotals{
  border-radius: 0%;
  background-color: #181918;
  width: 350px;
  /* padding-left: 10%; */
 /*  margin-left: 39.92%; */
  right: 0px;
  transition: none !important;
  position: absolute !important;
  z-index: 1000;
}
.iconham{
    height: 3px;
    background-color: #fff;
    margin-top: 0;
    margin-bottom: 0;
}
.btnnavmob{
    background-color: #15804d;
    height: 59px !important;
    width: 60px;
    margin-top: -12px !important;
    border: none !important;
    border-left: 1px solid #006639 !important;
    color: white;
    outline: none;
    position:absolute;
    right:0px;
}
.btnnavmob:active {
    border: left 1px solid rgb(18, 19, 18) !important;
    background-color: #181918;
}
.btnnavmob:focus {
    border: left 1px solid rgb(18, 19, 18) !important;
    background-color: #181918;
}
.iconmob{
    width: 60px;
    height: 45px;
}
.mobilenav{
    background-color: #169A5A;
    height: 60px;
    border: none;
}
.nav1{
    background-color: #169A5A;
    height: 70px;
    border: none;
}
.nav2{
    background-color: #15804d;
    border: 1px solid rgb(18, 19, 18);
    height: 70px;
}
.backcolor{
  background-color: #169A5A;
  border: none;
}
.logo{
    height: 35px;
    width: 168px;
    border: 1px solid #fff;
    margin-left: 44px;
    margin-top: -5px;
}
.flag{
    height: 25px;
    width: 35px;
    border: 0.02px solid #fff;
    margin-left: 24px;
    margin-top: -5px;
}
.iconlogo{
    height: 62px;
    width: 62px;
    
    margin-left: -15px;
    margin-top: -15px;
}

/* ////////////// */
.btn-group .button {
  background-color: #15804d; /* Green */
  border: 1px solid #006639;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  outline: none;
  height: 70px;
}

.btn-group .button:not(:last-child) {
  border-right: none; /* Prevent double borders */
}
/* .btn-group .button:focus{background-color:#181918;} */
.btn-group .button:hover {
  background-color: #006639;
}
.button:focus {
  outline: 2px solid #a4ceff !important;
}
.button_panel{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  color: #FFFFFF;
  size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  background: #169A5A;
  height: 33px;
  border: none;
}
.b-link:focus {
  outline: 2px solid #a4ceff !important;
  height: 30px;
}

.textfont{
font-family: 'DIN 2014-Regular';
color: #ffffff; 
font-size: 18px;
font-weight: 400;
height: 50px;
line-height: 38px;
margin: 0px;
}

.navfont{
color: #ffffff; 
font-family: 'DIN 2014-Regular';
font-size: 14.2px;
font-weight: 400;
height: 20px;
letter-spacing: 0.9px;
margin-inline-end: 0px;
display:inline-block;
}
.navlink{
  position: relative;
  left: 0%;
}
.cards{
  border-radius: 0%;
  background-color: #181918;
  height: 410px;
}
.cardnav{
  border-radius: 0%;
  background-color: #181918;
}
.cardhelp{
  border-radius: 0%;
  background-color: #181918;
  width: 674px;
  height: 178px;
  /* padding-left: 10%; */
  margin-left: 39.92%;
  transition: none !important;
  position: absolute;
  z-index: 1000;
}
.cardlang{
  border-radius: 0%;
  background-color: #181918;
  width: 242px;
  height: 208px;
  /* padding-left: 10%; */
  margin-left: 64.30%;

  position: absolute;
  z-index: 1000;
}
.collapseimg{
  max-width: 100%;
  height: 408px;
  margin-top: -20px;
  margin-left: 4%;
  position:absolute;
  right:0px;
}
.iconlang{
    height: 35px;
    width: 35px;
}
.signbtn {
  background-color: #15804d ;/* Green */
  border: none ;
  color: white;
  padding: 4px 5px;
  text-align: center;
  text-decoration: none ;
  display: inline-block;
  font-family: 'DIN 2014-ExraBold';
  font-size: 14px;

      /* font-family: 'DIN 2014', sans-serif;
    src: url('../assets/fonts/DIN2014-Regular.ttf');
    font-weight: 600;
    margin-left: 55px; */

}

.textmenu{
  font-family: 'DIN 2014-Regular', sans-serif;
  color: #169a5a;
  text-decoration: none !important;
  outline: 0;
  font-size: 15px;
}
a:hover {
  color: #fff !important;
  text-decoration: none !important;
  cursor: pointer;
}
.collapsing {
    transition:height 0.45s ease !important;
}
.titlefont{
 color: #ffffff; 
font-family: 'DIN 2014-Regular', sans-serif;
font-size: 21px;
font-weight: 400;
margin: 0px;
padding: 0px;

}
.divnav {
/*   text-align: right;
  margin:0px auto 0px auto;
  display:flex; */
  position:absolute;
  right:0px !important;
  top:5px
}
.helpbtn{
  background-color: #169a5a; 
color: #ffffff; 
font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
font-size: 14.4px;
font-weight: 700;
letter-spacing: 0.5px;
text-decoration: none;
height: 28px;
line-height: 14.4px;
margin: 0px;
padding: 4.5px 62.9px;
margin-top: 2px;
}
.titlehelp{
 color: #ffffff; 
font-family: 'DIN 2014-Regular', sans-serif;
font-size: 20px;
font-weight: 300;
height: 10px;
margin-top: 38px;
}
.no-transition {
    transition: none !important;
}
.disable-animations *,
.disable-animations *:after,
.disable-animations *:before {
    transition: none !important;
}
.cookie{
  background-color: #ecebeb !important;
  border-top: 4px solid #15804d !important;
}

.cookiebutton{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  color: #FFFFFF;
  size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  text-align: center;
  background: #169A5A;
  width: 40%;
  height: 36px;
  border: none;
  
}
.cookiebutton:hover{
  background:#006639;
}
.cookiebuttonwhite{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  color: #169A5A;
  size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  text-align: center;
  background: #ffffff;
  width: 40%;
  height: 36px;
  border: 2px solid #169A5A !important;

}
.cookiebuttonwhite:hover{
  background:#006639;
  border: none !important;
}
.cookietext{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  color: #000000;
  size: 14px;
  font-weight: 200;
}
.dropdown-menu{
  
  min-width: 23rem !important;
}
</style>